export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '작업내용'}, {name: '조사일'}, {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).inputB_1 // 유해위험요인분야-> 작업내용
      case 2: return func.getContent(value).inputB_5 // 조사일
      case 3: return func.getContent(value).stdInfo.writer_name // 작성자
      case 4: return func.getCreatedDate(value.created_at) // 작성일 // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '회사명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '작업내용': return ['content$body.inputB_1*%[:default_skw]%']
    case '조사일':  return ['content$body.inputB_5*%[:default_skw]%']
    case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.section*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }
    return []
  },
}
